import React from 'react';

const iconMoneyOut = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_6310_15295)">
      <path
        d="M20.0337 5.0028H3.14875C2.7225 5.0028 2.365 4.63891 2.365 4.20504C2.365 3.77117 2.7225 3.40728 3.14875 3.40728H17.6825C18.3287 3.40728 18.865 2.87544 18.865 2.20364C18.865 1.53184 18.3425 1 17.6825 1H3.14875C1.41625 1 0 2.44157 0 4.20504V17.795C0 19.5584 1.41625 21 3.14875 21H20.0475C21.1337 21 22.0138 20.1043 22.0138 18.9986V7.0042C22.0138 5.89853 21.1337 5.0028 20.0475 5.0028H20.0337ZM19.7313 15.6396C19.7313 16.3254 19.1812 16.8852 18.5075 16.8852C17.8337 16.8852 17.2837 16.3254 17.2837 15.6396V11.6088L10.7387 18.2708C10.2575 18.7607 9.4875 18.7607 9.00625 18.2708C8.525 17.781 8.525 16.9972 9.00625 16.5073L15.5513 9.84535H11.5913C10.9175 9.84535 10.3675 9.28551 10.3675 8.59972C10.3675 7.91393 10.9175 7.35409 11.5913 7.35409H18.4937C19.1675 7.35409 19.7175 7.91393 19.7175 8.59972V15.6256L19.7313 15.6396Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6310_15295">
        <rect width="22" height="20" fill="white" transform="translate(0 1)" />
      </clipPath>
    </defs>
  </svg>
);

export default iconMoneyOut;
